var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[_c('img',{attrs:{"src":require("../../../public/img/logo_cassems.png"),"width":"180"}})])
}]

export { render, staticRenderFns }